import React, { useState, useEffect, useContext } from "react";
import { useLocation } from 'react-router-dom';

import UserMenu from "../../Auth/components/UserMenu";
import { AppContext } from "../../../context/AppContext";
import FilterSummary from "./FilterSummary";
import FilterModal from "./FilterModal";
import useScreenSize from "../../../hooks/useScreenSize";
import "./styles.css";
import { Button } from "antd";

const NavigationBar = (props) => {
// access query params
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const cscReportId = searchParams.get('cscReportId');
  const {
  ensureProjects,
  selectedReportID,
  selectedReportDetails,
  selectedReportLoading,
  selectedReportStatus,
  setSelectedReportID,
  } = useContext(AppContext);

  const { isMobileTabletFilterModalOpen, closeMobileTabletFilterModal } = props;
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [forceSelectionMode, setForceSelectionMode] = useState(false);
  const screen = useScreenSize();
  const { isDesktop, isMobile, isTablet} = screen;


  useEffect(() => {
    ensureProjects().catch(() => {});
  }, [ensureProjects]);


  useEffect(() => {
    if (cscReportId) {
      setSelectedReportID(cscReportId);
    }
  }, [cscReportId, setSelectedReportID]);
  
  
  const closeFilterModal = () => {
    setIsFilterModalOpen(false);
  };

  // Force selection if no report is selected OR the selected report failed to load
  useEffect(() => {
    const noReport = !selectedReportID;
    const failed = !!selectedReportID && selectedReportStatus === 'error' && !selectedReportLoading && !selectedReportDetails;
    setForceSelectionMode(noReport || failed);
  }, [selectedReportID, selectedReportLoading, selectedReportDetails, selectedReportStatus]);

  // Auto-open the modal whenever required selections are missing
  useEffect(() => {
    if (forceSelectionMode) {
      setIsFilterModalOpen(true);
    }
  }, [forceSelectionMode]);


  // No-op: Modal handles apply & close

  return (
    <div style={{display: "contents"}}>
        <div className="nav-bar_content_desktop">
            <div className="navigation-bar__filters">
              <Button
                className="navbar-filter-summary"
                onClick={() => setIsFilterModalOpen(true)}
              >
                {isDesktop && <FilterSummary />}
              </Button>
            </div>
            <div className="navigation-bar__usermenu">
                <UserMenu />
            </div>
            {isDesktop && 
            <FilterModal isOpen={isFilterModalOpen} onClose={closeFilterModal} enforceSelection={forceSelectionMode} isDesktop={isDesktop} />}     
        </div>
        
        <div className="nav-bar_content_tablet_mobile">
            {(isMobile || isTablet) && 
            <FilterModal isOpen={isMobileTabletFilterModalOpen} onClose={closeMobileTabletFilterModal} enforceSelection={forceSelectionMode} isTablet={isTablet} isMobile={isMobile}/>}     
        </div>
    </div>
  );
};

export default NavigationBar;
